import $ from 'jquery';
import 'jquery-validation';
import { toggleButtonLoader } from '../utils/button-loader';
import CustomerSegment from './customer-segment';
import { AddTextToField } from '../components/add-text-to-field';
import { EmailTemplates } from '../components/email-templates';
import { Accordion } from '../components/accordion';
import { CodeMirrorEditor } from '../components/code-mirror-editor';
import CopyInputValue from '../components/copy-value';
import { ConfirmLinkModal } from '../components/confirm-link-modal';
import { DisableOnTargetValue } from '../components/disable-on-target-value';

export default class AjaxForm {
  constructor($ajaxForm, successUrl = '', successCallback = () => {}) {
    this.successCallback = successCallback;
    this.event = document.createEvent('Event');
    this.event.initEvent('resetRecaptcha', true, true);

    $ajaxForm.each((i, form) => {
      const $form = $(form);
      const $submitButton = $form.find('.js__submit-modal-form');
      this.initSubmitButton($submitButton, $form.data('success-url') ? $form.data('success-url') : successUrl);
    });
  }

  initSubmitButton($submitButton, successUrl) {
    $submitButton.on('click', e => {
      e.preventDefault();

      const $element = $(e.currentTarget);
      const $form = $element.closest('.js__ajax-form');
      const url = $form.attr('action');

      if ($form.data('ignore-validation') || $form.valid()) {
        this.submitForm($form, $element, url, successUrl, $form.data('success-template'));
      }
    });
  }

  submitForm($form, $element, url, successUrl, successTemplate) {
    toggleButtonLoader($element, true);
    $form.find('.js__form-general-error').addClass('d-none').html('');

    const xhr = $.ajax({
      method: $form.data('method') || 'POST',
      url,
      data: $form.serialize(),
    })
      .done(data => {
        const parameterToExtract = $form.data('add-response-value-to-input');
        const conditionalUrlValuePlaceholder = $form.data('conditional-url-value-placeholder');
        if (this.successCallback) {
          this.successCallback(data);
        }
        if (successTemplate) {
          $form.parent().html(data);
        } else if (successUrl || data.redirect) {
          window.location.assign(successUrl || data.redirect);
        } else if (parameterToExtract) {
          const $valueTarget = $($form.closest('.js__modal').data('add-response-value-target'));

          if ($valueTarget.length) {
            const $deleteButton = $valueTarget.parent().find('[data-form-collection="delete"]');

            $deleteButton.attr('data-form-collection', false);
            $deleteButton.attr('data-collection-delete-with-confirmation', true);
            $deleteButton.addClass('js__confirm-link-btn');
            ConfirmLinkModal.init($valueTarget.parent());
          }

          $valueTarget.val(data[parameterToExtract]);
          if (conditionalUrlValuePlaceholder) {
            const $conditionalElement = $valueTarget.parent().find('[data-conditional-url-value=""]');
            $conditionalElement.each((index, element) => {
              const $element = $(element);
              const conditionalUrl = $element.data('conditional-url-placeholder');

              $element.data('conditional-url-value', true);
              $element.attr(
                'data-conditional-url',
                conditionalUrl.replaceAll(conditionalUrlValuePlaceholder, data[parameterToExtract]),
              );
            });
          }
        } else if ($form.data('refresh-on-success')) {
          window.location.reload();
        }
        if ($form.data('close-modal-on-success')) {
          $form.closest('.modal').modal('hide');
        }
      })
      .fail(data => {
        if (xhr.status === 302 && xhr.responseJSON?.redirect) {
          window.location.href = xhr.responseJSON.redirect;
        } else {
          this.failHandle($form, data.responseText, successUrl);
        }
      })
      .always(() => {
        toggleButtonLoader($element, false);
      });

    return xhr;
  }

  failHandle($form, data, successUrl) {
    $form[0].dispatchEvent(this.event);

    if (data && $(data).find('.js__ajax-form').length) {
      $form.parent().html($(data).find('.js__ajax-form').get(0));

      const $newForm = $('.js__ajax-form');
      this.initScriptsOnNewForm($newForm);
      const $submitButton = $newForm.find('.js__submit-modal-form');
      this.initSubmitButton($submitButton, $newForm.data('success-url') ? $newForm.data('success-url') : successUrl);
      AddTextToField.init($newForm);
      DisableOnTargetValue.init($newForm);
    }
  }

  initScriptsOnNewForm($form) {
    CopyInputValue.init();
    CustomerSegment.searchSegmentsInit();
    EmailTemplates.init();
    Accordion.init($form);
    CodeMirrorEditor.init($form);
    $form.find('.ui.tabular.menu .item, .sylius-tabular-form .menu .item').tab();
    $form.find('.ui.accordion').addAccordionErrors();
  }
}
